import { createContext, useContext } from 'react';

/**
 * Contexto do toast. Vive fora de `Toast.tsx` porque aquele arquivo só exporta
 * componentes (`react-refresh/only-export-components`).
 */

export type ToastTone = 'sucesso' | 'erro' | 'aviso' | 'info';

export interface ToastOptions {
  tone?: ToastTone;
  /** Milissegundos até sumir sozinho. `0` mantém o aviso até alguém fechar. */
  duracaoMs?: number;
}

export interface ToastApi {
  /** Mostra um aviso efêmero. Um novo aviso substitui o anterior. */
  mostrar: (texto: string, options?: ToastOptions) => void;
  fechar: () => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** Acesso ao toast da árvore. Exige `<ToastProvider>` acima (App e `renderApp`). */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error('useToast: falta um <ToastProvider> acima na árvore.');
  return api;
}
